import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVar } from '../globals/global-var';
import { Observable } from 'rxjs';
import { Invite } from '../models/invite';
import { TeacherSituation } from '../models/teacher-situation';
import { StudentLeave } from '../models/student-leave';
import { StudentProfile } from '../models/student-profile';
import { Banner } from '../models/banner';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient, private globalVar: GlobalVar) { }

  getStudentNumberApi(): Observable<any> {
    return this.http.get<any>(this.globalVar.targetIp + '/api/Home/StudentNumber');
  }

  getTeacherNumberApi(): Observable<any> {
    return this.http.get<any>(this.globalVar.targetIp + '/api/Home/teacherNumber');
  }

  getInviteListApi(): Observable<Invite[]> {
    return this.http.get<Invite[]>(this.globalVar.targetIp + '/api/Home/InviteList');
  }

  getTeacherSituationListApi(month: string): Observable<TeacherSituation[]> {
    return this.http.get<TeacherSituation[]>(this.globalVar.targetIp + '/api/Home/TeacherSituationList/' + month);
  }

  getStudentLeaveListApi(month: string): Observable<StudentLeave[]> {
    return this.http.get<StudentLeave[]>(this.globalVar.targetIp + '/api/Home/StudentLeaveList/' + month);
  }


  getNonTuitionListApi(month: string): Observable<StudentProfile[]> {
    return this.http.get<StudentProfile[]>(this.globalVar.targetIp + '/api/Home/NonTuitionList/' + month);
  }

  getBannerApi(): Observable<Banner[]> {
    return this.http.get<Banner[]>(this.globalVar.targetIp + '/api/member/Banners');
  }

}
